
import { css } from 'lit';
export default css`
:host{
  display:contents;
}

.menu{
  display:flex;
  flex-direction:column;
  box-shadow:0px 4px 4px 0px rgba(91, 73, 108, 0.2);
  border-radius:0px 0px 16px 16px;
}

::slotted([slot='primary']),
::slotted([slot='ancillary']){
  display:flex;
  flex-direction:column;
}

::slotted([slot='ancillary']){
  border-radius:0px 0px 16px 16px;
  background-color:var(--neutral-light);
  padding:var(--spacing-4) var(--spacing-8) var(--spacing-6);
}

@media (min-width: 768px){
  .menu,
  ::slotted([slot='ancillary']){
    border-radius:0px 0px 0 16px;
  }
}

@media (min-width: 992px){
  .menu{
    box-shadow:none;
    border-radius:0;
  }

  ::slotted([slot='primary']){
    display:flex;
    flex-direction:row;
    justify-content:end;
    gap:var(--spacing-10);
  }

  ::slotted([slot='ancillary']){
    display:none;
  }
}
`;